// ─────────────────────────────────────────────────────────────────────────────
// PII Data Requests — module constants (BRD_PII_Data_Request_Flow, Part B §7).
// Backend: /api/pii-requests (proship_mongo, approval-engine tenant PII_DATA_REQUEST).
// ─────────────────────────────────────────────────────────────────────────────

// Access grants (users.accessList). Server enforces regardless — UI only shows/hides.
export const ROLE_REQUEST = 'PII_REQUEST'
export const ROLE_L1 = 'PII_APPROVER_L1'
export const ROLE_L2 = 'PII_APPROVER_L2'
export const ALL_PII_ROLES = [ROLE_REQUEST, ROLE_L1, ROLE_L2]

export const PATH = '/pii-requests'

// Status chip meta (BRD §7.3): label + MUI palette key; PROCESSING also spins.
export const STATUS_META = {
  PENDING_L1: { label: 'Pending L1', color: 'warning' },
  PENDING_L2: { label: 'Pending L2', color: 'info' },
  PROCESSING: { label: 'Processing', color: 'info', spinner: true },
  COMPLETED: { label: 'Completed', color: 'success' },
  REJECTED_L1: { label: 'Rejected (L1)', color: 'error' },
  REJECTED_L2: { label: 'Rejected (L2)', color: 'error' },
  FAILED: { label: 'Failed', color: 'error' },
  EXPIRED: { label: 'Expired', color: 'default' },
}

export const STATUS_FILTER_OPTIONS = Object.keys(STATUS_META)

// Client-side upload limits — mirror of backend config (server re-validates).
export const MAX_FILE_SIZE_MB = 2
export const MAX_AWB_COUNT = 5000
export const REASON_MIN = 20
export const REASON_MAX = 500

// My Requests auto-refreshes while any row is PROCESSING.
export const PROCESSING_POLL_MS = 20000

export const SAMPLE_CSV = 'awb_number\nSF123456789\nDL987654321\n'
